/**
 * MUDNAAZ FASHION — Global JavaScript
 */
(function () {
  'use strict';
  const revealObserver = new IntersectionObserver(
    (entries) => { entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-visible'); revealObserver.unobserve(e.target); } }); },
    { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
  );
  function initReveal() { document.querySelectorAll('.mn-reveal').forEach((el) => { revealObserver.observe(el); }); }
  function initStagger() {
    document.querySelectorAll('[data-mn-stagger]').forEach((grid) => {
      Array.from(grid.children).forEach((child, i) => { child.style.transitionDelay = `${i * 80}ms`; child.classList.add('mn-reveal'); revealObserver.observe(child); });
    });
  }
  function initHeader() {
    const header = document.querySelector('.header-wrapper, .shopify-section-header-group');
    if (!header) return;
    let ticking = false;
    window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(() => { header.classList.toggle('is-scrolled', window.scrollY > 40); ticking = false; }); ticking = true; } }, { passive: true });
  }
  function initParallax() {
    const parallaxEls = document.querySelectorAll('[data-mn-parallax]');
    if (!parallaxEls.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let ticking = false;
    window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(() => { parallaxEls.forEach((el) => { const rect = el.closest('section')?.getBoundingClientRect(); if (!rect) return; el.style.transform = `translateY(${rect.top * (parseFloat(el.dataset.mnParallax) || 0.3)}px)`; }); ticking = false; }); ticking = true; } }, { passive: true });
  }
  function initWhatsApp() { const wa = document.querySelector('.mn-whatsapp-float'); if (!wa) return; setTimeout(() => wa.classList.add('mn-reveal', 'is-visible'), 2000); }
  function init() { initReveal(); initStagger(); initHeader(); initParallax(); initWhatsApp(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', () => { initReveal(); initStagger(); });
})();
